import { render, staticRenderFns } from "./syncDatasource.vue?vue&type=template&id=038165a6&scoped=true"
import script from "./syncDatasource.vue?vue&type=script&lang=js"
export * from "./syncDatasource.vue?vue&type=script&lang=js"
import style0 from "./syncDatasource.vue?vue&type=style&index=0&id=038165a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038165a6",
  null
  
)

export default component.exports